import { apiFetcher } from '@gjensidige/service-async';

import { WidgetProps } from '../interfaces/Types';

// Import local images
import familyLifeKitchen from '../images/familyLifeKitchen.webp';
import familyLifeKitchenSmall from '../images/familyLifeKitchenSmall.webp';
import cuddleHomeCouple from '../images/cuddleHomeCouple.webp';
import cuddleHomeCoupleSmall from '../images/cuddleHomeCoupleSmall.webp';

export class AppHelper {
  static CUSTOMER_PHONE_NR_SESSION_KEY = 'customerPhoneNr';
  static phoneNumberErrorText =
    'Ange mobilnumret med 10 siffror och utan bindestreck eller mellanslag.';
  static phoneNrHelpText =
    'Vi ringer gärna upp dig och hjälper dig hitta rätt försäkring för dina behov.';

  static getDynamicImageInfo = (selectedHouseType: string) => {
    switch (selectedHouseType) {
      case 'bostadsratt':
        return {
          image: cuddleHomeCouple,
          smallScreenImage: cuddleHomeCoupleSmall,
          imageAltText: 'Par som myser hemma'
        };
      case 'hyresratt':
      default:
        // Use familyLifeKitchen as fallback for hyresratt and when no house type is selected
        return {
          image: familyLifeKitchen,
          smallScreenImage: familyLifeKitchenSmall,
          imageAltText: 'Familjeliv i köket'
        };
    }
  };

  static getDefaultData = (): WidgetProps => {
    const defaultImageInfo = AppHelper.getDynamicImageInfo('');

    return {
      headerText: 'Se pris och köp hemförsäkring',
      selectedHouseType: '',
      tenancyLabel: 'Hyresrätt',
      ownedLabel: 'Bostadsrätt',
      cprNumberLabel: 'Ditt personnummer',
      cprNumberPlaceHolder: 'ÅÅÅÅMMDDNNNN',
      cprInvalidMessage: 'Vänligen kontrollera personnumret',
      ageBelow18Text: 'Du måste vara över 18 år för att köpa en försäkring',
      addressErrorText: 'Vänligen kontrollera gatuadress',
      zipCodeErrorText: 'Vänligen kontrollera postnumret',
      cprNumberHelpText:
        'Vi behöver ditt personnummer för att kunna ge dig rätt pris. Personnumret ger oss bland annat uppgifter om var du bor och din ålder.',
      zipCodeLabel: 'Postnummer',
      addressLabel: 'Gatuadress',
      calculateBtnLabel: 'Se ditt pris',
      footerMessage: '',
      personalDataHandlingInfoLinkText:
        'Läs mer om vår hantering av dina personuppgifter',
      personalDataHandlinkUrl: '/om-oss/gdpr',
      imageInfo: defaultImageInfo
    };
  };

  static getEnonicContent = async (dataUrl: string) => {
    const response: any = await apiFetcher.postJson(dataUrl);
    let enonicData = {};
    if (response.isOk()) {
      if (response.value) {
        enonicData = response.value;
      }
    }
    return enonicData;
  };

  static prepareData = (defaultData: WidgetProps, additionalData: any) => {
    const selectedHouseType = additionalData?.selectedHouseType || defaultData.selectedHouseType;
    const dynamicImageInfo = AppHelper.getDynamicImageInfo(selectedHouseType);

    const housingTypeHeaderText = selectedHouseType ?
      selectedHouseType === 'hyresratt'
        ? 'Se pris och köp hemförsäkring för hyresrätt'
        : 'Se pris och köp hemförsäkring för bostadsrätt'
      : additionalData?.headerText;

    return {
      headerText: housingTypeHeaderText || defaultData?.headerText,
      selectedHouseType: selectedHouseType,
      tenancyLabel: additionalData?.tenancyLabel || defaultData.tenancyLabel,
      ownedLabel: additionalData?.ownedLabel || defaultData.ownedLabel,
      cprNumberLabel:
        additionalData?.cprNumberLabel || defaultData.cprNumberLabel,
      cprNumberPlaceHolder:
        additionalData?.cprNumberPlaceHolder ||
        defaultData.cprNumberPlaceHolder,
      cprNumberHelpText:
        additionalData?.cprNumberHelpText || defaultData.cprNumberHelpText,
      zipCodeLabel: additionalData?.zipCodeLabel || defaultData.zipCodeLabel,
      addressLabel: additionalData?.addressLabel || defaultData.addressLabel,
      calculateBtnLabel:
        additionalData?.calculateBtnLabel || defaultData.calculateBtnLabel,
      cprInvalidMessage:
        additionalData?.cprInvalidMessage || defaultData.cprInvalidMessage,
      ageBelow18Text:
        additionalData?.ageBelow18Text || defaultData.ageBelow18Text,
      addressErrorText:
        additionalData?.addressErrorText || defaultData.addressErrorText,
      zipCodeErrorText:
        additionalData?.zipCodeErrorText || defaultData.zipCodeErrorText,
      footerMessage: additionalData?.footerMessage || defaultData.footerMessage,
      personalDataHandlingInfoLinkText:
        additionalData?.personalDataHandlingInfoLinkText ||
        defaultData.personalDataHandlingInfoLinkText,
      personalDataHandlinkUrl:
        additionalData?.personalDataHandlinkUrl ||
        defaultData.personalDataHandlinkUrl,
      imageInfo: {
        image: dynamicImageInfo.image,
        smallScreenImage: dynamicImageInfo.smallScreenImage,
        imageAltText: dynamicImageInfo.imageAltText
      }
    };
  };
}
